import {
  DropdownMenuCheckboxItem,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  Icon,
  MoreMenu,
} from "@qw/ui";
import { useInsuredFiles } from "../../hooks";
import { useOpenFilePicker } from "./external-dropzone";

export const FilesOptions = () => {
  const openFilePicker = useOpenFilePicker();
  const {
    correspondence,
    deletedFiles,
    fileLabels,
    setCorrespondence,
    setDeletedFiles,
    setFileLabels,
    setSelectedTags,
  } = useInsuredFiles();
  return (
    <MoreMenu>
      <DropdownMenuItem onClick={openFilePicker}>
        <Icon icon="upload_file" />
        Upload file
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuLabel>Options</DropdownMenuLabel>
      <DropdownMenuCheckboxItem
        checked={correspondence}
        onCheckedChange={(val) => {
          setCorrespondence(val);
          setSelectedTags("");
        }}
      >
        Display Correspondence
      </DropdownMenuCheckboxItem>
      <DropdownMenuCheckboxItem checked={fileLabels} onCheckedChange={(val) => setFileLabels(val)}>
        Display Labels
      </DropdownMenuCheckboxItem>
      <DropdownMenuCheckboxItem checked={deletedFiles} onCheckedChange={(val) => setDeletedFiles(val)}>
        Display Deleted Files
      </DropdownMenuCheckboxItem>
    </MoreMenu>
  );
};
